import { Action } from '@ngrx/store';
import {
    PlanEntry,
    PlanFilterInput
} from 'app/api/plan.api.service';
import { KeyStringFilterInput } from 'app/api/common.api.types';
import { UpdatePlanEntryInput } from 'app/api/API.service';

export interface PlanQuery {
    companyId: string;
    account?: KeyStringFilterInput;
    filter?: PlanFilterInput;
}

export enum PlanActionTypes {
    PlanRequested = '[Plan View] Plan requested',
    PlanLoaded = '[Plan API] Plan loaded',
    PlanCancelled = '[Plan API] Plan cancelled',
    PlanEntryUpdateRequested = '[Plan View] Plan entry update requested',
    PlanEntryUpdated = '[Plan API] Plan entry updated',
    PlanEntryUpdateCancelled = '[Plan API] Plan entry update cancelled',
}

// LOAD ENTRIES
export class PlanRequested implements Action {
    readonly type = PlanActionTypes.PlanRequested;
    constructor(public payload: PlanQuery) {}
}
export class PlanLoaded implements Action {
    readonly type = PlanActionTypes.PlanLoaded;
    constructor(public payload: { plan: PlanEntry[] }) {}
}
export class PlanCancelled implements Action {
    readonly type = PlanActionTypes.PlanCancelled;
    constructor(public payload: { errorMessage: string }) {}
}

// UPDATE ENTRY
export class PlanEntryUpdateRequested implements Action {
    readonly type = PlanActionTypes.PlanEntryUpdateRequested;
    constructor(public payload: { input: UpdatePlanEntryInput }) {}
}
export class PlanEntryUpdated implements Action {
    readonly type = PlanActionTypes.PlanEntryUpdated;
    constructor(public payload: { entry: PlanEntry }) {}
}
export class PlanEntryUpdateCancelled implements Action {
    readonly type = PlanActionTypes.PlanEntryUpdateCancelled;
    constructor(public payload: { errorMessage: string }) {}
}

export type PlanActions =
  PlanRequested
    | PlanLoaded
    | PlanCancelled
    | PlanEntryUpdateRequested
    | PlanEntryUpdated
    | PlanEntryUpdateCancelled;
